import React from 'react'
import { Container } from 'react-bootstrap'

export const PrivacyPolicy = () => {
  return (
    <div className='mt-5'>
      <section className='mt-5'>
        <img className='w-100' src={require("../Assets/Privacy/Privacy_policy-01.jpg")} alt="Privacy_policy" loading='lazy'/>
      </section>
      <section className='my-5'>
        <Container className='text-start'>
          <h1>Privacy Policy for PiLog Group</h1>
          <p className='my-3'>At PiLog Group, accessible from https://piloggroup.com, one of our main priorities is the privacy of our visitors. This Privacy Policy statement contains types of information that are collected and recorded by PiLog Group and how we use it.</p>
          <p className='my-3'>
            If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
          </p>
          <p className='my-3'>
            This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in PiLog Group. This policy does not apply to any information collected offline or via channels other than this website.
          </p>
          <div>
            <h3>Consent</h3>
            <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
          </div>
        </Container>

      </section>
      <section>
        <Container className='text-start'>

          <div>
            <h3>Information we collect</h3>
            <p className='my-3'>
            The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
            </p>
            <p className='my-3'>
            If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
            </p>
            <p className='my-3'>
            When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
            </p>
          </div>
          <div>
            <h3>How we use your information</h3>
            <div>
              <p>We use the information we collect in various ways, including to:</p>
              <ul>
                <li>Provide, operate, and maintain our website</li>
                <li>Improve, personalize, and expand our website</li>
                <li>Understand and analyze how you use our website</li>
                <li>Develop new products, services, features, and functionality</li>
                
              </ul>

            </div>
            <p className='my-3'>
            Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the webste, and for marketing and promotional purposes
            </p>
            <p className='my-3'>
            PiLog Group follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files includes internet protocol ( IP ) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any personally identifiable information. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information. Our Privacy Policy was created with the help of the Privacy Policy Generator and the Online Privacy Policy Generator.
            </p>
           
          </div>
        </Container>
      </section>
    </div>
  )
}
